import { render } from "./OldOrder.vue?vue&type=template&id=5c6deb79&scoped=true"
import script from "./OldOrder.vue?vue&type=script&lang=js"
export * from "./OldOrder.vue?vue&type=script&lang=js"

import "./OldOrder.vue?vue&type=style&index=0&id=5c6deb79&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/kds-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6deb79"]])

export default __exports__